var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6173 10.6983L19.9459 3.5H18.4463L12.9511 9.75022L8.56215 3.5H3.5L10.137 12.9514L3.5 20.5H4.99977L10.8028 13.8996L15.4379 20.5H20.5L13.6169 10.6983H13.6173ZM11.5632 13.0347L10.8907 12.0936L5.54016 4.60473H7.84371L12.1617 10.6485L12.8341 11.5896L18.447 19.4455H16.1434L11.5632 13.0351V13.0347Z",
    fill: "#C6FCA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9e52067322de5f7d8e33ae8d6bfe662e.svg";
export { ForwardRef as ReactComponent };